module.exports = "h3,\nh4,\nh5 {\n  margin: 0;\n}\n.item__stats {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  border: 1px solid #bbb;\n  border-radius: 4px;\n  padding: 0.25em 1em;\n  margin: 0.5em 0;\n}\nh5 > small {\n  float: right;\n  font-weight: 400;\n}\nh5:after {\n  clear: right;\n}\n.card .desc {\n  font-size: 0.875em;\n  color: #555;\n  text-align: justify;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/items/items.component.less
// module id = ./src/app/items/items.component.less
// module chunks = main